import { tapJournal } from '../journal/journalSync';
import { api } from './http';

export type ModernizationCostSplit = 'shares' | 'personal';

export type Modernization = {
  id: number;
  description: string;
  performed_by: string;
  performed_at: string;
  cost: number;
  cost_split?: ModernizationCostSplit | null;
  payer_user_id?: number | null;
  created_at?: string;
  created_by?: number | null;
  comment?: string | null;
};

export const getModernizations = () =>
  api.get<Modernization[]>('/modernizations');
export type ModernizationPayload = {
  description: string;
  performed_by: string;
  performed_at: string;
  cost: number;
  cost_split?: ModernizationCostSplit;
  payer_user_id?: number;
  comment?: string;
};

export const addModernization = (data: ModernizationPayload) =>
  tapJournal(
    api.post<Modernization & { added: boolean }>('/modernizations', null, {
      params: data,
    })
  );

export const updateModernization = (
  modernizationId: number,
  data: ModernizationPayload
) =>
  tapJournal(
    api.put<Modernization & { updated: boolean }>(
      `/modernizations/${modernizationId}`,
      null,
      { params: data }
    )
  );

export const deleteModernization = (modernizationId: number) =>
  tapJournal(
    api.delete<{ deleted: boolean }>(`/modernizations/${modernizationId}`)
  );
